var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgCitrine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5304 1.46482L68.5439 31.4783C70.4936 33.428 70.4936 36.5808 68.5439 38.5305L38.5304 68.5367C36.5807 70.4864 33.4279 70.4864 31.4782 68.5367L1.46476 38.5305C-0.484917 36.5808 -0.484917 33.428 1.46476 31.4783L31.471 1.46482C33.4207 -0.484856 36.5807 -0.484856 38.5304 1.46482Z",
    fill: "#F7702D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5359 31.4703L38.5297 1.46409C36.58 -0.485589 33.4272 -0.485589 31.4775 1.46409L1.46407 31.4703C1.44957 31.4848 1.44232 31.492 1.43507 31.4993C0.159447 32.7894 1.17415 35 2.98612 35H67.0139C68.8258 35 69.8405 32.7967 68.5649 31.4993C68.5577 31.492 68.5504 31.4848 68.5359 31.4703Z",
    fill: "#F99C38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6992 35L33.4997 69.0433C34.1086 70.2827 35.877 70.2827 36.4859 69.0433L53.2864 35H16.6992Z",
    fill: "#F99C38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.507 0.956697L16.6992 35H53.2937L36.4931 0.956697C35.8843 -0.275442 34.1158 -0.275442 33.507 0.956697Z",
    fill: "#FFE888"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.07 47.8939L16.7064 34.9927H14.5175H10.0528C9.07436 34.9927 8.58151 36.1813 9.2773 36.8699L21.461 49.0536C22.2583 49.8653 23.5774 48.9231 23.07 47.8939Z",
    fill: "#FFDA71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.93 22.0987L53.2936 34.9999H55.4825H59.9472C60.9256 34.9999 61.4185 33.8113 60.7227 33.1227L48.5535 20.939C47.7417 20.1273 46.4226 21.0767 46.93 22.0987Z",
    fill: "#E5483C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitrine);
export default __webpack_public_path__ + "static/media/citrine.13a6afc5.svg";
export { ForwardRef as ReactComponent };